import { get } from '@client/lib/request';

export const fetchFooter = () => get('/mylounge-api/footer');
